import styled, { keyframes } from 'styled-components';

const scroll = keyframes`
  from { transform: translateX(0); }
  to   { transform: translateX(-50%); }
`;

export const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
  padding-block: ${({ theme }) => theme.spacing[8]};

  /* Fade nas bordas */
  mask-image: linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%);
  -webkit-mask-image: linear-gradient(
    to right,
    transparent 0%,
    black 10%,
    black 90%,
    transparent 100%
  );
`;

export const Track = styled.div`
  display: flex;
  align-items: center;
  width: max-content;
  animation: ${scroll} 30s linear infinite;

  /* Pausa no hover */
  &:hover {
    animation-play-state: paused;
  }
`;

export const LogoItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-inline: ${({ theme }) => theme.spacing[10]};
  flex-shrink: 0;
`;

export const LogoImg = styled.img`
  height: 90px;
  width: auto;
  object-fit: contain;
  transition: filter 0.3s ease;
`;

export const SectionLabel = styled.p`
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.xs};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  letter-spacing: ${({ theme }) => theme.letterSpacings.widest};
  text-transform: uppercase;
  color: ${({ theme }) => theme.semantic.text.muted};
  margin-bottom: ${({ theme }) => theme.spacing[4]};
`;
